import type { GallerySetupConfig, GalleryExitConfig, GallerySizeMap } from '@/types/GallerySetupConfig'
import {
  DAM_IMAGE_AUTOHEIGHT_SRCSET_CONFIG,
  DAM_IMAGE_RATIO4x3_HEIGHT_DEFAULT,
  DAM_IMAGE_RATIO4x3_SRCSET_CONFIG,
  DAM_IMAGE_RATIO4x3_WIDTH_DEFAULT,
} from '@/config/image'

export function useGalleryConfigSetup() {
  const DEFAULT_EXIT_DOMAIN = 'https://www.sme.sk/?ref=no-gallery-referer'
  const createDefaultExitSetup = (): GalleryExitConfig => {
    return {
      fromArticleNode: true,
      defaultUrl: DEFAULT_EXIT_DOMAIN,
      documentUrl: DEFAULT_EXIT_DOMAIN,
      latestArticle: ''
    }
  }

  const createDefaultSizeMap = (): GallerySizeMap => {
    return {
      autoHeightSrcSet: DAM_IMAGE_AUTOHEIGHT_SRCSET_CONFIG,
      ratio4x3DefaultWidth: DAM_IMAGE_RATIO4x3_WIDTH_DEFAULT,
      ratio4x3DefaultHeight: DAM_IMAGE_RATIO4x3_HEIGHT_DEFAULT,
      ratio4x3SrcSet: DAM_IMAGE_RATIO4x3_SRCSET_CONFIG,
    }
  }

  const createDefaultSetupConfig = (): GallerySetupConfig => {
    return {
      damBaseUrlImage: '',
      imageAuthorPropertyKey: 'author',
      headLogoName: 'Blog',
      exit: createDefaultExitSetup(),
      sizeMap: createDefaultSizeMap(),
      navigationReloadAfter: -1,
      socialShareEnabled: true,
    }
  }

  const resolveConfig = (config: GallerySetupConfig): GallerySetupConfig => {
    return Object.assign(createDefaultSetupConfig(), config)
  }

  const resolveGalleryExit = (config: GallerySetupConfig, articleUri: string | null = null): string => {
    if (config.exit?.fromArticleNode && articleUri) {
      return '/' + articleUri
    }

    const queryVal = getQueryParameter(config.exit?.queryParam ?? 'exit')
    if (queryVal && config.exit?.documentUrl) {
      return config.exit.documentUrl + queryVal
    }

    if (config.exit?.latestArticle && config.exit?.documentUrl) {
      return config.exit.documentUrl + config.exit.latestArticle
    }

    return config.exit ? config.exit.defaultUrl : DEFAULT_EXIT_DOMAIN
  }

  const getQueryParameter = (name: string, url: string = window.location.href): null | string => {
    name = name.replace(/[[\]]/g, '\\$&')

    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url)

    if (!results) {
      return null
    }

    if (!results[2]) {
      return ''
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  return {
    createDefaultSetupConfig,
    resolveConfig,
    resolveGalleryExit,
  }
}
